/** ページパラメータのキーバリューストアのインターフェース */
export interface KeyValueStore {
  removeItem: (key: string) => void
  setItem: (key: string, value: string) => void
  getItem: (key: string) => string | null
}

/**
 * キーバリューストアインスタンス
 *
 * DIのためにexportしているが、テスト以外では直接使わない
 * */
export let kvs: KeyValueStore // eslint-disable-line import/no-mutable-exports

/** キーバリューストアの初期化関数 */
export const initializeKVS = (kvsInstance: KeyValueStore): void => {
  kvs = kvsInstance
}

/** キー一覧 */
export const pageParamKeys = {
  UNIT_PARAMS: 'page.unit',
  ANSWER_PARAMS: 'page.answer',
  VIEWER_PARAMS: 'page.viewer',
  VIEWER_CONTENTS: 'page.viewer.ViewerContents',
  FULL_DIGITAL: 'page.fullDigital',
  SUBMIT_PREVIEW: 'page.submitPreview',
  TEISHUTSU_PREVIEW: 'page.teishutsuPreview',
} as const
export type PageParamKeys = typeof pageParamKeys[keyof typeof pageParamKeys]
